import { BaseRequest } from '@/network/requests/BaseRequest';
import { user_rights_group_detail } from '@/interfaces/user_rights_group_detail';

export const userRightsGroupDetailRequest = BaseRequest.build<user_rights_group_detail>('user_rights_group_detail');